'use strict';

angular.module('far.profile')
.controller('AscentProfileController', function (
	$log,
	$http,
	$window,
	$timeout,
	$scope,
	$location,
	Ascents,
	mountainRegions,
	mountainPeaks,
	mountainRoutes,
	ascentEditForm,
	showModalMessage,
	UserRelation
) {
	var vm = {
		getDocumentUrl: getDocumentUrl,
		progress: false,
		ascentModel: ascentEditForm(),
		getAscent: getAscent,
		submit: submit,
		newAscent: newAscent,
		selectedPeak: null,
		userId: null,
		isEditAscent: false,
		showAscentsForm: false,
		mountain: null,
		alerts: [],
		ascents: [],
        masterSelected: null,
		showAdditionalField: showAdditionalField,
		editAscent: editAscent,
		deleteAscent: deleteAscent,
		closeAlert: function(index) {
			vm.alerts.splice(index, 1);
		}
	};

	function showAdditionalField(field) {
        if (field.name === 'master_selector') {
			return vm.ascent.ascent_user_type
				&& vm.ascent.ascent_user_type.id === vm.ascent_user_types.participant.id;
        }

        if(field.name === 'user_chief'){
            return vm.ascent.ascent_user_type
				&& vm.ascent.ascent_user_type.id === vm.ascent_user_types.participant.id
				&& vm.masterSelected !== null
				&& vm.masterSelected.model === vm.ascent_user_types.chief.system_name;
		}

        if(field.name === 'user_instructor'){
            return vm.ascent.ascent_user_type
				&& vm.ascent.ascent_user_type.id === vm.ascent_user_types.participant.id
                && vm.masterSelected !== null
				&& vm.masterSelected.model === vm.ascent_user_types.instructor.system_name;
        }
    }

	function ascentFormAdditionals() {
		vm.ascentModel.$fields.ascent_type.options.class = 'form__item form__item_select';
		vm.ascentModel.$fields.ascent_user_type.options.class = 'form__item form__item_select';
		vm.ascentModel.$fields.ascent_mountain_route.options.class = 'form__item form__item_select';
        vm.ascentModel.$fields.master_selector.radio.model = vm.masterSelected;
		vm.ascentModel.$fields.master_selector.radioAttributes.onSelect = function(item){
			vm.masterSelected = item;
		};
		vm.ascentModel.$fields.ascent_mountain_peak.uiSelectOptions.onSelect = function(item) {
			if (item && item.id != vm.selectedPeak) {
				vm.selectedPeak = item;
				refreshMountainRouteAutoComplete();
			}
		};
		vm.ascentModel.$fields.user_chief.uiSelectOptions.onSelect = function(item, model, options) {
			vm.ascent.updateUser(options.index, item);
		};
        vm.ascentModel.$fields.user_instructor.uiSelectOptions.onSelect = function(item, model, options) {
            vm.ascent.updateUser(options.index, item);
        };
		vm.ascentModel.$fields.user_participant.uiSelectOptions.onSelect = function (item, model, options) {
			vm.ascent.updateUser(options.index, item);
		};
		vm.ascentModel.$fields.documentsFiles.uploader.removeFromQueue = function(value) {
			var index = this.getIndexOfItem(value);
			var item = this.queue[index];

			if (item.isUploading) {
				item.cancel();
			} else {
				vm.documents_files.splice(index, 1);
			}

			this.queue.splice(index, 1);
			item._destroy();

			this.progress = this._getTotalProgress();
		};
	}
	ascentFormAdditionals();

	function getDocumentUrl(file_id) {
		return Routing.generate('api_upload_get_file', {fileStorage: file_id});
	}

	function getAscent() {
		vm.ascent = Ascents.new({}, vm.ascent_user_types);
		vm.progress = false;
	}

	function refreshMountainRouteAutoComplete() {
		$http.get(Routing.generate('api_entities_get_mountainroutes', {
			offset: 0,
			limit: 100,
			peak_id: vm.selectedPeak.id,
			list: 1
		})).then(function(response) {
			vm.ascentModel.$fields.ascent_mountain_route.items.length = 0;

			angular.forEach(response.data, function (route) {
				vm.ascentModel.$fields.ascent_mountain_route.items.push(route[0]);
			});
		}).catch(function(response) {
			$log.error(response);
		});
	}

	function deleteAscent(ascentId) {
		var ascent = { id: ascentId };

		Ascents
			.delete(ascent)
			.then(function() {
				$window.location.reload(true);
			})
			.catch( function(response) {
				$log.error(response);
				vm.alerts.push({
					type: 'danger',
					message: 'Не удалось удалить восхождение. Попробуйте повторить попытку через некоторое время.'
				});
				vm.progress = false;
			});
	}

	function editAscent(ascentId) {
		vm.ascentModel.$fields.documentsFiles.uploader.clearQueue();
		vm.masterSelected = null;

		vm.ascent = Ascents.get(arguments[0], vm.ascent_user_types, function (ascentData) {
            vm.ascent.ascent_users.filter(function(user){
            	if(user.user && user.user.id === vm.userId){
            		vm.ascent.ascent_user_type = user.ascent_user_type_id;
				}
				if(user.user && (user.ascent_user_type_id.id === vm.ascent_user_types.chief.id || user.ascent_user_type_id.id === vm.ascent_user_types.instructor.id)){
                    var radioItem = vm.ascentModel.$fields.master_selector.items.filter(function(item){
                    	return item.model === user.ascent_user_type_id.system_name
					});
                    vm.masterSelected = radioItem.length ? radioItem[0] : null;
				}
			});
			vm.ascent.ascent_date = new Date(vm.ascent.ascent_date);
			vm.selectedPeak = ascentData.ascent_mountain_route.mountain_peaks[0];
			refreshMountainRouteAutoComplete();

			vm.isEditAscent = true;
			vm.progress = false;
		});
	}

	function newAscent(route) {
		vm.progress = true;
		if (vm.isEditAscent) {
			vm.isEditAscent = false;
			vm.showAscentsForm = false;
		}

		vm.ascent = Ascents.new({}, vm.ascent_user_types);

		if (route) {
			vm.ascent.ascent_mountain_route = route;
			vm.selectedPeak = route.mountain_peaks[0];
			refreshMountainRouteAutoComplete();
		} else {
			vm.selectedPeak = null;
		}


		vm.ascentModel = undefined;
		$timeout(function() {
			vm.ascentModel = ascentEditForm();
			ascentFormAdditionals();
			vm.showAscentsForm = !vm.showAscentsForm;
			vm.progress = false;
		});
	}

	function submit() {
		if (vm.progress || !$scope.ascentForm.$valid) {
			return;
		}

        var ascent_users_error = true;

        vm.ascent.ascent_users.filter(function(user) {
            if (user.user) {
                ascent_users_error = false;
            }
        });

        if (ascent_users_error) {
            //vm.ascent.ascent_users_error = true;

            //return;
		} else {
            //vm.ascent.ascent_users_error = null;
        }

		vm.progress = true;
		vm.showAscentsForm = false;
		vm.isEditAscent = false;

        var addUser = true;

        vm.ascent.ascent_users.map(function(user) {
            if (user.user && (user.user.id == vm.userId)) {
                addUser = false;
                user.ascent_user_type_id = vm.ascent.ascent_user_type;
            }

            if(vm.masterSelected && vm.masterSelected.model === 'chief' && user.user && user.ascent_user_type_id.id == vm.ascent_user_types.instructor.id){
            	vm.ascent.deleteUser(user);
			}
            if(vm.masterSelected && vm.masterSelected.model === 'instructor' && user.user && user.ascent_user_type_id.id == vm.ascent_user_types.chief.id){
                vm.ascent.deleteUser(user);
            }
        });

        if (addUser) {
            var _user = vm.ascent.createUser(vm.ascent.ascent_user_type);

            vm.ascent.updateUser(_user.uniqId, {id: vm.userId});
        }

		vm.ascent.save()
			.then(function() {
				$window.location.reload(true);
			})
			.catch(function(response) {
				$log.error(response);
				showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
				vm.progress = false;
			});
	}

	if (angular.isDefined($location.search().mountainroute)) {
		mountainRoutes.get($location.search().mountainroute, function(route) {
			newAscent(route);
		});
	}

	return vm;
});
